// Netzstand aus Sicht der App (Phase 6). navigator.onLine allein reicht nicht: im Laden mit WLAN ohne Internet
// meldet das Handy "online", die Daten kommen aber aus dem Service-Worker-Cache. Der markiert solche Antworten
// mit X-Nebenbei-Cache (vite.config.ts); api() meldet hier, ob die letzte Antwort echt oder aus dem Cache war.
import { useSyncExternalStore } from 'react';

let ohneNetz = typeof navigator !== 'undefined' && navigator.onLine === false;
const hoerer = new Set<() => void>();

function setzen(wert: boolean): void {
  if (wert === ohneNetz) return;
  ohneNetz = wert;
  for (const h of hoerer) h();
}

export const netz = {
  istOhne: () => ohneNetz,
  ausCache: () => setzen(true),
  fehler: () => setzen(true),
  erreicht: () => setzen(false),
};

if (typeof window !== 'undefined') {
  window.addEventListener('offline', () => setzen(true));
}

export function useOhneNetz(): boolean {
  return useSyncExternalStore(
    (h) => {
      hoerer.add(h);
      return () => hoerer.delete(h);
    },
    () => ohneNetz,
  );
}
